
const INDEX_OF_NOT_EXIST = -1;

export const isFlashScoreStream = (stream_url: string): boolean => stream_url && stream_url.toLowerCase()
    .search('flashscore.com') !== INDEX_OF_NOT_EXIST;

export const isTwitchStream = (stream_url: string): boolean => stream_url && stream_url.toLowerCase()
    .search('twitch.tv') !== INDEX_OF_NOT_EXIST;
